import axiosInstance from "../utils/axios";

export const getReports = async (params) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
  return axiosInstance.get('/api/reports', { headers, params });
};

export const deleteReport = async (reportId) => {
  const headers = { Authorization: `Bearer ${localStorage.getItem("accessToken")}` };
  return axiosInstance.delete(`/api/reports/${reportId}`, { headers });
};
